import {TranslationObject} from '@colonist/i18n'
import {BaseCardData, CardClickPopupType} from '@colonist/game-card-types'
import {CardEnum, CardTypeEnum, TurnState} from '@colonist/game-states'

export class CardProgressTradeCardBack extends BaseCardData {
    cardEnum = CardEnum.ProgressCardTradeBack
    cardTypeEnum = CardTypeEnum.ProgressTrade
    isCardBack = true
    imageFileName = 'card_progress_trade_back'
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.trade.back.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.trade.back.body'}
    clickPopupType = CardClickPopupType.None
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.trade.back.popupBody'}
    allowableTurnStates = undefined
}

export class CardProgressTradeCommercialHarbor extends BaseCardData {
    cardEnum = CardEnum.ProgressCardTradeCommercialHarbor
    cardTypeEnum = CardTypeEnum.ProgressTrade
    isCardBack = false
    imageFileName = 'card_progress_trade_commercial_harbor'
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.trade.commercialHarbor.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.trade.commercialHarbor.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.trade.commercialHarbor.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressTradeMasterMerchant extends BaseCardData {
    cardEnum = CardEnum.ProgressCardTradeMasterMerchant
    cardTypeEnum = CardTypeEnum.ProgressTrade
    isCardBack = false
    imageFileName = 'card_progress_trade_master_merchant'
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.trade.masterMerchant.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.trade.masterMerchant.body'}
    clickPopupType = CardClickPopupType.NormalClick
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.trade.masterMerchant.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressTradeMerchant extends BaseCardData {
    cardEnum = CardEnum.ProgressCardTradeMerchant
    cardTypeEnum = CardTypeEnum.ProgressTrade
    isCardBack = false
    imageFileName = 'card_progress_trade_merchant'
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.trade.merchant.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.trade.merchant.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.trade.merchant.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressTradeMerchantFleet extends BaseCardData {
    cardEnum = CardEnum.ProgressCardTradeMerchantFleet
    cardTypeEnum = CardTypeEnum.ProgressTrade
    isCardBack = false
    imageFileName = 'card_progress_trade_merchant_fleet'
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.trade.merchantFleet.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.trade.merchantFleet.body'}
    clickPopupType = CardClickPopupType.NormalClick
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.trade.merchantFleet.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressTradeResourceMonopoly extends BaseCardData {
    cardEnum = CardEnum.ProgressCardTradeResourceMonopoly
    cardTypeEnum = CardTypeEnum.ProgressTrade
    isCardBack = false
    imageFileName = 'card_progress_trade_resource_monopoly'
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.trade.resourceMonopoly.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.trade.resourceMonopoly.body'}
    clickPopupType = CardClickPopupType.NormalClick
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.trade.resourceMonopoly.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressTradeCommodityMonopoly extends BaseCardData {
    cardEnum = CardEnum.ProgressCardTradeCommodityMonopoly
    cardTypeEnum = CardTypeEnum.ProgressTrade
    isCardBack = false
    imageFileName = 'card_progress_trade_commodity_monopoly'
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.trade.commodityMonopoly.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.trade.commodityMonopoly.body'}
    clickPopupType = CardClickPopupType.NormalClick
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.trade.commodityMonopoly.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}
